import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export const WhatsAppOptIn = () => {
  const [d, setD] = useState(null);
  const [phone, setPhone] = useState("");
  useEffect(() => { api.get("/whatsapp/opt-in").then((r) => { setD(r.data); setPhone(r.data.phone); }).catch(() => {}); }, []);
  if (!d) return null;
  const save = async (opt) => {
    try { const { data } = await api.put("/whatsapp/opt-in", { opt_in: opt, phone }); setD(data); toast.success(opt ? "WhatsApp-Hinweise aktiviert" : "WhatsApp-Hinweise deaktiviert"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  return (
    <div className="border border-slate-200 bg-white px-4 py-3 flex items-center gap-3 flex-wrap text-sm" data-testid="wa-optin">
      <span className="text-slate-700">WhatsApp-Hinweise zu Terminen &amp; Chat-Nachrichten</span>
      <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Handynummer" className="input-tech w-44 text-sm" data-testid="wa-optin-phone" />
      <button onClick={() => save(!d.opt_in)} className={`px-3 py-1.5 text-xs ${d.opt_in ? "border border-slate-300" : "bg-emerald-600 text-white"}`} data-testid="wa-optin-toggle">{d.opt_in ? "Deaktivieren" : "Aktivieren"}</button>
      {d.opt_in && <span className="text-xs text-emerald-700" data-testid="wa-optin-active">aktiv</span>}
    </div>
  );
};
